import {Map, fromJS, List} from "immutable";

import {
    GET_ALERTS_SUCCESS,
    GET_ALERTS_REQUEST,
    GET_ALERTS_ERROR,

    CHANGE_STATUS_ALERT_REQUEST,
    CHANGE_STATUS_ALERT_SUCCESS,
    CHANGE_STATUS_ALERT_ERROR,

    CLEAN_ALERTS
} from '../actions/alerts';

const alerts = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_ALERTS_REQUEST:
      case CHANGE_STATUS_ALERT_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_ALERTS_SUCCESS:
      case CLEAN_ALERTS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CHANGE_STATUS_ALERT_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              // Find the index of the project to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });
              // Update the payload list
              if (index !== -1) {
                  if (action.payload.status !== 'archived') {
                      updatedPayload = payload.update(index, () => {
                          return fromJS(action.payload);
                      });
                  }
                  else {
                      updatedPayload = payload.filter( alert => {
                          return alert.get('_id') !== action.payload._id;
                      });
                  }
              }
          }
          // If payload is a Map the payload to be updated is action.payload itself
          else if(Map.isMap(state.get('payload'))) {
              if (action.payload.status !== 'archived') updatedPayload = fromJS(action.payload);
              else updatedPayload = fromJS({});
          }

          newState = state
              .merge({
                  isFetching: action.isFetching,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;

      // Errors
      case GET_ALERTS_ERROR:
      case CHANGE_STATUS_ALERT_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default alerts;



// WEBPACK FOOTER //
// ./src/reducers/alerts.js